import { Database, Constants } from './database.types';

export type ContentStatus = Database['public']['Enums']['content_status'];

const STATUS_LABELS: Record<ContentStatus, string> = {
  draft: 'Draft',
  published: 'Published',
  archived: 'Archived',
};

export const CONTENT_STATUS_OPTIONS: { value: ContentStatus; label: string }[] =
  Constants.public.Enums.content_status.map((status) => ({
    value: status,
    label: STATUS_LABELS[status],
  }));

// For filter dropdowns that need an "All" option
export const CONTENT_STATUS_FILTER_OPTIONS: { value: string; label: string }[] = [
  { value: '', label: 'All Statuses' },
  ...CONTENT_STATUS_OPTIONS,
];

export const CONTENT_STATUS_BADGE_COLORS: Record<ContentStatus, string> = {
  draft: 'bg-orange-100 text-orange-800',
  published: 'bg-green-100 text-green-800',
  archived: 'bg-gray-100 text-gray-600',
};
